// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--ulzKO";